import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";

import { CONTACT_DETAILS, CREDIT, LEGAL_LINKS, ROUTES } from "../../data/content";
import { FacebookIcon, InstagramIcon, WhatsAppIcon } from "../general/Icons";

const SOCIALS = [
  { label: "Candlewoods Guesthouse on Facebook", link: CONTACT_DETAILS.FACEBOOK_LINK, Icon: FacebookIcon },
  { label: "Candlewoods Guesthouse on Instagram", link: CONTACT_DETAILS.INSTAGRAM_LINK, Icon: InstagramIcon },
];

const Footer = () => {
  return (
    <React.Fragment>
      <footer className={"site-footer"}>
        <div className={"site-footer-inner container"}>
          <div className={"site-footer-col"}>
            <p>
              Tel:{" "}
              <a href={CONTACT_DETAILS.TEL.link}>{CONTACT_DETAILS.TEL.label}</a>
              <br />
              Cell:{" "}
              <a href={CONTACT_DETAILS.CELL.link}>{CONTACT_DETAILS.CELL.label}</a>
              <br />
              E-mail:{" "}
              <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
            </p>
            <Link
              to={ROUTES.BOOK}
              className={"site-footer-underline"}
            >
              Book a Room
            </Link>
          </div>

          <div className={"site-footer-col"}>
            <nav aria-label={"Legal"}>
              <ul className={"site-footer-legal"}>
                {LEGAL_LINKS.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className={"site-footer-underline"}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
            <p className={"site-footer-follow"}>Follow us</p>
            <ul className={"site-footer-socials"}>
              {SOCIALS.map(({ label, link, Icon }) => (
                <li key={link}>
                  <a
                    href={link}
                    target={"_blank"}
                    rel={"noopener noreferrer"}
                    aria-label={label}
                  >
                    <Icon />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className={"site-footer-badges"}>
            <a
              href={CONTACT_DETAILS.LEKKESLAAP_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <img
                src={"/images/badges/lekkeslaap.png"}
                alt={"LekkeSlaap 2025 - 4.9 out of 5"}
                width={112}
                height={135}
                loading={"lazy"}
              />
            </a>
            <img
              src={"/images/badges/booking-com.png"}
              alt={"Booking.com Traveller Review Awards 2025 - 9.1"}
              width={135}
              height={135}
              loading={"lazy"}
            />
          </div>

          <p className={"site-footer-credit"}>
            © {new Date().getFullYear()} by Candlewoods Guesthouse. Created by{" "}
            <a
              href={CREDIT.link}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              {CREDIT.label}
            </a>
            .
          </p>
        </div>
      </footer>

      <a
        href={CONTACT_DETAILS.WHATSAPP_LINK}
        className={"whatsapp-button"}
        target={"_blank"}
        rel={"noopener noreferrer"}
        aria-label={"Chat to us on WhatsApp"}
      >
        <WhatsAppIcon />
      </a>
    </React.Fragment>
  );
};

export default Footer;
